/* Mock data for non-learner role workflows */

export const CM_IDENTITY = {
  name: 'Maya Reyes',
  role: 'Case Manager',
  facility: 'Collin County Detention Center',
  facilityShort: 'Collin County DC',
  activeLearners: 14,
};

export const IN_IDENTITY = {
  name: 'Dr. Sandra Kim',
  role: 'Instructor',
  modules: ['AI Foundations', 'HVAC Fundamentals'],
  activeLearners: 31,
};

export const EP_IDENTITY = {
  name: 'James Whitfield',
  title: 'Talent Acquisition Manager',
  company: 'TechForce Solutions',
  partnerSince: 'January 2025',
};

export const AD_IDENTITY = {
  name: 'LaVar McCline',
  role: 'TTI Admin',
};

/* Shared learner registry — surfaced by all role views */
export const LEARNERS = [
  {
    id: 'jonathan',
    firstName: 'Jonathan',
    lastInitial: 'T.',
    facilityId: 'CC-2451',
    facility: 'Collin County DC',
    module: 'HVAC Fundamentals',
    moduleId: 'hvac',
    progress: 68,
    releaseDate: 'Aug 14, 2025',
    daysToRelease: 47,
    status: 'active',
    lastActivity: 'Today',
    kcAvg: 78,
    lessons: [
      { title: 'Refrigeration Cycle Fundamentals', status: 'complete', score: 92 },
      { title: 'Reading Wiring Diagrams', status: 'complete', score: 78 },
      { title: 'Safe Refrigerant Recovery', status: 'in-progress', score: null },
    ],
    credentialsEarned: [{ name: 'CompTIA A+', pct: 100 }],
    credentialsInProgress: [{ name: 'EPA 608', pct: 68 }],
    matchStrength: 'strong',
    skills: 'HVAC systems, refrigerant handling, equipment maintenance, safety protocols',
    caseNote: 'Strong communicator, consistent attendance, motivated to enter the trades.',
    education: 'High school diploma',
  },
  {
    id: 'darnell',
    firstName: 'Darnell',
    lastInitial: 'W.',
    facilityId: 'CC-2308',
    facility: 'Collin County DC',
    module: 'AI Foundations',
    moduleId: 'ai-foundations',
    progress: 22,
    releaseDate: 'Nov 3, 2025',
    daysToRelease: 128,
    status: 'at-risk',
    lastActivity: '4 days ago',
    kcAvg: 54,
    lessons: [
      { title: 'Fundamentals & Career Pathways', status: 'complete', score: 66 },
      { title: 'How Language Models Work', status: 'in-progress', score: null },
      { title: 'Responsible AI in the Workplace', status: 'locked', score: null },
    ],
    credentialsEarned: [],
    credentialsInProgress: [{ name: 'CompTIA AI+', pct: 22 }],
    flagReason: 'Missed 3 sessions in the past week',
    matchStrength: 'good',
    skills: 'Data literacy, prompt engineering, documentation',
    caseNote: 'Missed sessions may correlate with medical intake week. Follow up scheduled.',
    education: 'Some college',
  },
  {
    id: 'keisha',
    firstName: 'Keisha',
    lastInitial: 'M.',
    facilityId: 'CC-2201',
    facility: 'Collin County DC',
    module: 'HVAC Fundamentals',
    moduleId: 'hvac',
    progress: 100,
    releaseDate: 'Jul 22, 2025',
    daysToRelease: 24,
    status: 'release-soon',
    lastActivity: 'Yesterday',
    kcAvg: 88,
    lessons: [
      { title: 'Refrigeration Cycle Fundamentals', status: 'complete', score: 94 },
      { title: 'Reading Wiring Diagrams', status: 'complete', score: 86 },
      { title: 'Safe Refrigerant Recovery', status: 'complete', score: 84 },
    ],
    credentialsEarned: [{ name: 'EPA 608', pct: 100 }],
    credentialsInProgress: [],
    matchStrength: 'strong',
    skills: 'HVAC service, EPA compliance, mentorship-ready',
    caseNote: 'Credential completed. Ready for employer handoff.',
    education: 'High school diploma',
  },
  {
    id: 'jerome',
    firstName: 'Jerome',
    lastInitial: 'L.',
    facilityId: 'CC-2144',
    facility: 'Collin County DC',
    module: 'HVAC Fundamentals',
    moduleId: 'hvac',
    progress: 55,
    releaseDate: 'Oct 12, 2025',
    daysToRelease: 106,
    status: 'active',
    lastActivity: 'Today',
    kcAvg: 72,
    lessons: [
      { title: 'Refrigeration Cycle Fundamentals', status: 'complete', score: 80 },
      { title: 'Reading Wiring Diagrams', status: 'in-progress', score: null },
      { title: 'Safe Refrigerant Recovery', status: 'locked', score: null },
    ],
    credentialsEarned: [],
    credentialsInProgress: [{ name: 'EPA 608', pct: 55 }],
    matchStrength: 'good',
    skills: 'HVAC install, customer communication',
    caseNote: 'Reentry plan updated with housing referral.',
    education: 'High school diploma',
  },
  {
    id: 'antoine',
    firstName: 'Antoine',
    lastInitial: 'B.',
    facilityId: 'CC-2087',
    facility: 'Collin County DC',
    module: 'HVAC Fundamentals',
    moduleId: 'hvac',
    progress: 41,
    releaseDate: 'Dec 1, 2025',
    daysToRelease: 156,
    status: 'active',
    lastActivity: 'Today',
    kcAvg: 69,
    lessons: [
      { title: 'Refrigeration Cycle Fundamentals', status: 'complete', score: 72 },
      { title: 'Reading Wiring Diagrams', status: 'in-progress', score: null },
      { title: 'Safe Refrigerant Recovery', status: 'locked', score: null },
    ],
    credentialsEarned: [],
    credentialsInProgress: [{ name: 'EPA 608', pct: 41 }],
    matchStrength: 'good',
    skills: 'HVAC install, jobsite safety',
    caseNote: 'Matched with Lone Star Energy Partners.',
    education: 'Trade certification',
  },
];

/* Case Manager activity feed */
export const CM_ACTIVITY = [
  { learnerId: 'jonathan', text: 'Jonathan T. completed Lesson 4 — HVAC Fundamentals', when: '2 hours ago' },
  { learnerId: 'darnell', text: 'Darnell W. flagged: missed 3 sessions', when: '5 hours ago', tone: 'orange' },
  { learnerId: 'keisha', text: 'Keisha M. earned EPA 608 Certification', when: 'Yesterday', tone: 'success' },
  { learnerId: 'jerome', text: 'Jerome L. updated reentry plan', when: '2 days ago' },
  { learnerId: 'antoine', text: 'Antoine B. matched with Lone Star Energy Partners', when: '3 days ago' },
];

/* Reentry plan checklist defaults */
export const REENTRY_CHECKLIST = [
  { key: 'edu', label: 'Education program enrolled', default: true },
  { key: 'cred', label: 'Credential pathway identified', default: true },
  { key: 'id', label: 'ID and documentation requested', default: false },
  { key: 'housing', label: 'Housing referral completed', default: false },
  { key: 'transport', label: 'Transportation plan confirmed', default: false },
  { key: 'benefits', label: 'Benefits enrollment initiated', default: false },
  { key: 'employer', label: 'Employer contact established', default: false },
  { key: 'support', label: 'Post-release support assigned', default: false },
];

/* Instructor assessment mock */
export const IN_ASSESSMENT = {
  moduleId: 'ai-foundations',
  moduleName: 'AI Foundations',
  checkNumber: 3,
  avgScore: 74,
  high: 98,
  low: 41,
  belowThreshold: ['darnell', 'antoine', 'jerome'],
  questions: [
    {
      text: 'What is the primary responsibility of a Data Annotator?',
      correctPct: 82,
      commonWrong: 'Building custom models',
      correctAnswer: 'Labeling training data with quality guidelines',
      explanation: 'Annotators translate raw data into structured training input.',
    },
    {
      text: 'Which practice reflects Responsible AI use at work?',
      correctPct: 61,
      commonWrong: 'Trust every AI output',
      correctAnswer: 'Verify outputs and never share sensitive data with public tools',
      explanation: 'Verification prevents hallucinated facts from reaching customers.',
    },
    {
      text: 'What does the "context window" of an LLM refer to?',
      correctPct: 78,
      commonWrong: 'The subscription tier',
      correctAnswer: 'How much text the model can process in one turn',
      explanation: 'Context window is a fixed-size buffer, measured in tokens.',
    },
  ],
};

/* Employer partner data */
export const EP_JOB_POSTINGS = [
  {
    id: 'hvac-entry',
    title: 'HVAC Technician — Entry Level',
    department: 'Building Systems',
    salary: '$45,000–$55,000',
    matched: 4,
    secondChance: true,
  },
  {
    id: 'ai-ops',
    title: 'AI Operations Analyst',
    department: 'Cloud Services',
    salary: '$52,000–$68,000',
    matched: 2,
    secondChance: true,
  },
];

export const EP_IMPACT = {
  hires: 2,
  matched: 8,
  pipeline: 4,
  retention: 87,
  avgWage: '$48,200',
  timeline: [
    { month: 'Jan', matched: 2, hired: 0 },
    { month: 'Feb', matched: 3, hired: 1 },
    { month: 'Mar', matched: 4, hired: 0 },
    { month: 'Apr', matched: 5, hired: 1 },
    { month: 'May', matched: 6, hired: 0 },
    { month: 'Jun', matched: 8, hired: 2 },
  ],
};

/* Admin platform stats */
export const AD_STATS = {
  learners: 247,
  facilities: 3,
  credentials: 89,
  employers: 38,
  modules: 12,
  completionRate: 74,
};

export const AD_ALERTS = [
  { key: 'mods-pending', label: '2 modules pending approval', href: 'modules' },
  { key: 'partner-req', label: '1 new employer partner request', href: 'users' },
  { key: 'at-risk', label: '4 learners flagged at-risk', href: 'users' },
];

export const AD_FACILITIES = [
  { name: 'Collin County DC', learners: 94, modules: 31 },
  { name: 'Dallas County DC', learners: 87, modules: 28 },
  { name: 'Tarrant County DC', learners: 66, modules: 22 },
];

export const AD_USERS = [
  { id: 'u-jonathan', name: 'Jonathan T.', role: 'Learner', facility: 'Collin County DC', status: 'Active', lastActive: 'Today' },
  { id: 'u-darnell', name: 'Darnell W.', role: 'Learner', facility: 'Collin County DC', status: 'At-risk', lastActive: '4 days ago' },
  { id: 'u-jordan', name: 'Jordan M.', role: 'Youth Learner', facility: 'Collin County Youth Center', status: 'Active', lastActive: 'Today' },
  { id: 'u-maya', name: 'Maya Reyes', role: 'Case Manager', facility: 'Collin County DC', status: 'Active', lastActive: 'Today' },
  { id: 'u-sandra', name: 'Dr. Sandra Kim', role: 'Instructor', facility: 'Collin County DC', status: 'Active', lastActive: 'Yesterday' },
  { id: 'u-james', name: 'James Whitfield', role: 'Employer', facility: 'TechForce Solutions', status: 'Active', lastActive: '3 days ago' },
  { id: 'u-priya', name: 'Priya Ramanathan', role: 'Case Manager', facility: 'Dallas County DC', status: 'Active', lastActive: 'Today' },
  { id: 'u-derek', name: 'Derek Osei', role: 'Instructor', facility: 'Tarrant County DC', status: 'Active', lastActive: 'Yesterday' },
  { id: 'u-lena', name: 'Lena Rodriguez', role: 'Employer', facility: 'Lone Star Energy Partners', status: 'Active', lastActive: 'Last week' },
];

export const AD_MODULES = [
  { name: 'AI Foundations', status: 'active', enrolled: 84, completion: 62, credential: 'CompTIA AI+' },
  { name: 'HVAC Fundamentals', status: 'active', enrolled: 96, completion: 71, credential: 'EPA 608' },
  { name: 'Medical Assistant Essentials', status: 'active', enrolled: 67, completion: 58, credential: 'NHA CCMA' },
  { name: 'Cybersecurity Essentials', status: 'pending', enrolled: 0, completion: 0, credential: 'CompTIA Security+' },
  { name: 'Solar Installation Basics', status: 'pending', enrolled: 0, completion: 0, credential: 'NABCEP Associate' },
  { name: 'Commercial Driving Prep', status: 'active', enrolled: 41, completion: 66, credential: 'CDL Class A' },
  { name: 'Plumbing Fundamentals', status: 'active', enrolled: 38, completion: 71, credential: 'Journeyman Prep' },
  { name: 'Electrical Wiring Basics', status: 'active', enrolled: 44, completion: 68, credential: 'NEC Prep' },
  { name: 'Culinary Foundations', status: 'active', enrolled: 22, completion: 55, credential: 'ServSafe' },
  { name: 'Financial Literacy', status: 'active', enrolled: 132, completion: 82, credential: 'Certificate' },
  { name: 'Digital Fluency', status: 'active', enrolled: 88, completion: 74, credential: 'Certificate' },
  { name: 'Business Fundamentals', status: 'draft', enrolled: 0, completion: 0, credential: 'Certificate' },
];
